var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "24px",
    viewBox: "0 0 28 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu-icon",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hamburger-Menu",
    transform: "translate(0.120000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06666667,0 C0.477562934,0 0,0.671572875 0,1.5 C0,2.32842712 0.477562934,3 1.06666667,3 L26.6666667,3 C27.2557704,3 27.7333333,2.32842712 27.7333333,1.5 C27.7333333,0.671572875 27.2557704,0 26.6666667,0 L1.06666667,0 Z M0,10.0333333 C0,9.20490621 0.477562934,8.53333333 1.06666667,8.53333333 L26.6666667,8.53333333 C27.2557704,8.53333333 27.7333333,9.20490621 27.7333333,10.0333333 C27.7333333,10.8617605 27.2557704,11.5333333 26.6666667,11.5333333 L1.06666667,11.5333333 C0.477562934,11.5333333 0,10.8617605 0,10.0333333 Z M0,18.5666667 C0,17.7382395 0.477562934,17.0666667 1.06666667,17.0666667 L26.6666667,17.0666667 C27.2557704,17.0666667 27.7333333,17.7382395 27.7333333,18.5666667 C27.7333333,19.3950938 27.2557704,20.0666667 26.6666667,20.0666667 L1.06666667,20.0666667 C0.477562934,20.0666667 0,19.3950938 0,18.5666667 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/Menu-icon.920f37267a26b062ac5780abff595749.svg";
export { ForwardRef as ReactComponent };